module.exports = __webpack_public_path__ + "Roboto-normal-300.ecce92d0b0ff17197f29.woff";


//////////////////
// WEBPACK FOOTER
// ./~/inspinia/dist/Roboto-normal-300.woff
// module id = 904
// module chunks = 2